import { Tooltip } from 'react-tooltip';

export const StatebarButtonsTooltips = () => {
  return (
    <>
      <Tooltip
        anchorSelect="#state-doesAppDirExist-icon"
        place="top"
        content="Does App Dir Exist"
        delayShow={500}
      />
      <Tooltip
        anchorSelect="#state-isAppInstalled-icon"
        place="top"
        content="Is App Installed"
        delayShow={500}
      />
      <Tooltip
        anchorSelect="#state-doesAppNeedRepair-icon"
        place="top"
        content="Does App Need Repair"
        delayShow={500}
      />
      <Tooltip
        anchorSelect="#state-isAppUpdateAvailable-icon"
        place="top"
        content="Is App Update Available"
        delayShow={500}
      />
      <Tooltip
        anchorSelect="#state-doesAppOngoingTaskExist-icon"
        place="top"
        content="Does Any Task Exist"
        delayShow={500}
      />
      <Tooltip
        anchorSelect="#state-doesAppOngoingInstallTaskExist-icon"
        place="top"
        content="Does Ongoing Install Task Exist"
        delayShow={500}
      />
      <Tooltip
        anchorSelect="#state-doesAppOngoingUpdateTaskExist-icon"
        place="top"
        content="Does Ongoing Update Task Exist"
        delayShow={500}
      />
      <Tooltip
        anchorSelect="#state-doesAppOngoingUninstallTaskExist-icon"
        place="top"
        content="Does Ongoing Uninstall Task Exist"
        delayShow={500}
      />
      <Tooltip
        anchorSelect="#state-doesAppOngoingRepairTaskExist-icon"
        place="top"
        content="Does Ongoing Repair Task Exist"
        delayShow={500}
      />
      <Tooltip
        anchorSelect="#state-doesAppOngoingMoveTaskExist-icon"
        place="top"
        content="Does Ongoing Move Task Exist"
        delayShow={500}
      />
      <Tooltip
        anchorSelect="#state-doesAppLastTaskFailed-icon"
        place="top"
        content="Does Last Task Failed"
        delayShow={500}
      />
    </>
  );
};
